import React from 'react';
import PropTypes from 'prop-types';
import AmountInput from '../AmountInput';
import CategoryCombobox from '../CategoryCombobox';
import PayeeInput from '../PayeeInput';
import categoryProp from '../../propTypes/category';
import earmarkProp from '../../propTypes/earmark';

const EarmarkForm = ({ earmark, categories, onUpdate }) => (
  <div className="grid grid-cols-3 gap-4">
    <div className="col-span-3">
      <label className="label">Category</label>

      <CategoryCombobox
        category={categories.find((category) => category.id === earmark.category_id)}
        categories={categories}
        onChange={(value) => onUpdate({ category_id: value.id })}
      />
    </div>

    <div className="col-span-2">
      <label className="label">Payee</label>

      <PayeeInput payee={earmark.payee} onChange={(payee) => onUpdate({ payee })} />
    </div>

    <div className="col-span-1">
      <label className="label">Amount</label>

      <AmountInput amount={earmark.amount} onChange={(value) => onUpdate({ amount: value })} />
    </div>
  </div>
);

EarmarkForm.propTypes = {
  earmark: earmarkProp.isRequired,
  categories: PropTypes.arrayOf(categoryProp),
  onUpdate: PropTypes.func.isRequired
};

export default EarmarkForm;
